// extracted by mini-css-extract-plugin
export default {"popup_wrap":"style_popup_wrap__Kq+ZO","sub_title":"style_sub_title__evY-K","stu_wrap":"style_stu_wrap__mvrco","stu_item":"style_stu_item__AKus4"};